import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ngcArrayCountries'
})
export class ArrayCountriesPipe implements PipeTransform {

    transform(countries: Array<any>, region: string): any {
        if (region) {
            return countries.filter((el) => el.region == region );
        } else {
            return [];
        }
    }

}
